import {
  authorizeGetRequest,
  authorizePatchRequest,
  authorizePutRequest,
} from "api";
import { IApiResponse, IPaginatedResponse } from "models";
import {
  IDriverWallet,
  IDriverWalletDetailResponse,
  IUpdateDriverWalletBalance,
  IUpdateDriverWalletInput,
} from "models/driverWallet";

export const walletsApi = (page: number, perPage: number, search: string, useCache: boolean = false) => {
  search = search.replace("+", "%2B");
  return authorizeGetRequest<IPaginatedResponse<IDriverWallet>>(
    `wallets?page=${page}&per_page=${perPage}&search=${search}`,
    useCache
  );
};

export const fetchWalletByIdApi = (id: string, useCache: boolean = false) => {
  return authorizeGetRequest<IApiResponse<IDriverWallet>>(`wallets/${id}`, useCache);
};

export const fetchWalletDetailApi = (
  id: string,
  page: number,
  perPage: number
) => {
  return authorizeGetRequest<IDriverWalletDetailResponse>(
    `wallets/${id}/detail?page=${page}&per_page=${perPage}`
  );
};

export const fetchWalletDetailByDriverIdApi = (
  id: string,
  page: number,
  perPage: number
) => {
  return authorizeGetRequest<IDriverWalletDetailResponse>(
    `wallets/driver/${id}/detail?page=${page}&per_page=${perPage}`
  );
};

export const updateWalletApi = (id: string, data: IUpdateDriverWalletInput) => {
  return authorizePatchRequest<IApiResponse<IDriverWallet>>(
    `wallets/${id}`,
    data
  );
};

export const deduceWalletApi = (
  id: string,
  data: IUpdateDriverWalletBalance
) => {
  return authorizePutRequest<IApiResponse<IDriverWallet>>(
    `wallets/${id}/balance/deduct`,
    data
  );
};

export const addWalletApi = (id: string, data: IUpdateDriverWalletBalance) => {
  return authorizePutRequest<IApiResponse<IDriverWallet>>(
    `wallets/${id}/balance/add`,
    data
  );
};
